import { useEffect } from 'react';

import { usePostListingById } from 'src/hooks/usePostListing';

export const usePaymentSuccessPostListing = (listingId: string | null) => {
  const postListingById = usePostListingById();

  useEffect(() => {
    if (
      typeof listingId === 'string' &&
      postListingById.status.kind === 'idle'
    ) {
      postListingById.post(listingId);
    }
  }, [listingId, postListingById]);

  return postListingById.status;
};
